import React, { useState } from 'react'
import { create as ipfsHttpClient } from 'ipfs-http-client'
const ipfs = ipfsHttpClient('https://ipfs.infura.io:5001/api/v0')
const videoPlaceholder = `data:image/jpeg;base64,/9j/4QC8RXhpZgAASUkqAAgAAAAGABIBAwABAAAAAQAAABoBBQABA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`

export const VideoUpload = ({ setUrl }) => {
    const [video, setVideo] = useState({})
    const [imagePreview, setImagePreview] = useState('')
    const [loading, setLoading] = useState(false)
    const [uploaded, setUploaded] = useState(false)

    const createPreview = (e) => {
        if (e.target.value !== '') {
            setVideo(e.target.files[0])
            //const src = URL.createObjectURL(videoPlaceholder)
            //URL.createObjectURL(e.target.files[0])
            setImagePreview(videoPlaceholder)
        } else {
            setImagePreview('')
        }
    }

    const uploadFile = async (e) => {
        setLoading(true)
        e.preventDefault()

        try {
            const added = await ipfs.add(video)
            const url = `https://ipfs.infura.io/ipfs/${added.path}`
            setUrl(url)
            setImagePreview(url)
            setUploaded(true)
        } catch (err) {
            console.log('Error uploading the file : ', err)
        }
        setLoading(false)
    }

    const previewAndUploadButton = () => {
        if (imagePreview !== '') {
            if (!loading) {
                return (
                    <div>
                        {uploaded ? (
                            <h5>
                                ✅{' '}
                                <a
                                    href={imagePreview}
                                    target='_blank'
                                    rel='noopener noreferrer'
                                >
                                    Video
                                </a>{' '}
                                Uploaded Successfully ✅{' '}
                            </h5>
                        ) : (
                            <div className='mt-3'>
                                <button type='submit' className='inline-flex justify-center py-2 px-4 text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 rounded-md border border-transparent focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 shadow-sm'>
                                    Upload Video
                                </button>
                                <h5 className='mt-3 mb-3'>
                                    {video.name}{' '}
                                    <span className='bg-green-900 text-white text-sm font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-green-200 dark:text-green-900'>
                                        {video.size} kb
                                    </span>
                                </h5>

                                <img
                                    style={{ height: '300px' }}
                                    className='box-content h-32 w-32 p-3 border-3 mb-3'
                                    src={imagePreview}
                                />
                            </div>
                        )}
                    </div>
                )
            } else {
                return (
                    <div className="grid grid-cols-1 gap-y-6 mt-4 sm:grid-cols-3 sm:gap-x-4">
                        <h4>Uploading Video</h4>
                        <div className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
                            <div className="bg-blue-600 h-2.5 rounded-full" style="width: 69%"></div>
                        </div>
                        <h4>Please Wait ...</h4>
                    </div>
                )
            }
        }
    }

    return (
        <div>
            <form onSubmit={uploadFile}>
                <input
                    required
                    type='file'
                    accept='video/*'
                    onChange={(e) => createPreview(e)}
                    className='p-3 text-sm bg-white rounded border-0 focus:outline-none focus:ring shadow transition-all duration-150 ease-linear placeholder:text-blueGray-300 text-blueGray-600'
                />

                {previewAndUploadButton()}
            </form>
        </div>
    )
}
